// extracted by mini-css-extract-plugin
export default {"option":"RenderText_option__dlKDa","correct":"RenderText_correct__TPVab"};